/* @flow */

import React from 'react';
import { Redirect } from 'react-router-dom';

import { create, read, update } from 'permissions/customerAccounts';
import CustomerAccountsReportView from 'tables/CustomerAccountsReportView/CustomerAccountsReportView';
import CustomerAccountForm from 'forms/CustomerAccountForm';

const customerAccountsRoutes = [
  {
    path: '/customer-accounts',
    title: 'general:document_titles.customer_accounts.title',
    component: CustomerAccountsReportView,
    exact: true,
    permissions: read,
  },
  {
    path: '/customer-accounts/create',
    title: 'general:document_titles.customer_accounts.create',
    component: () => <CustomerAccountForm mode="create" />,
    exact: true,
    permissions: create,
  },
  {
    path: '/customer-accounts/edit/:dataType/:customerAccountId/:companyCode',
    title: 'general:document_titles.customer_accounts.edit',
    title_keys: ['selectedCustomerAccountDataSource', 'selectedCustomerAccount.name'],
    component: (props: Object) => (
      <CustomerAccountForm
        mode="edit"
        dataSource={props.match.params.dataType}
        customerAccountId={props.match.params.customerAccountId}
        companyCode={props.match.params.companyCode}
      />
    ),
    exact: true,
    permissions: update,
  },
];

export default customerAccountsRoutes.map(item => ({
  ...item,
  store: ['customerAccountStore'],
}));
